import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { Button, InputUI, Typography } from "@parkschannel/ui";
import { useTags } from "../../../../Tags/hooks";
import { AdvancedFiltersNavigationHeader } from "../AdvancedFiltersComponents";
import { DebouncedSearch } from "../../../../Forms/DebouncedSearch";
export function AdvancedFiltersTags(param) {
    let { onBack , onFilter , initialTags  } = param;
    const [search, setSearch] = useState("");
    const { register , handleSubmit  } = useForm({
        defaultValues: {
            selectedStates: initialTags
        }
    });
    const { useGetTagsQuery  } = useTags();
    const { data: tags  } = useGetTagsQuery({
        page: 1,
        limit: 1000,
        search: search
    }, {
        keepPreviousData: true
    });
    const onSubmit = (data)=>{
        onFilter(data.selectedStates);
    };
    const onSearch = (value)=>{
        if (!value) return setSearch("");
        setSearch(value);
    };
    const renderTagsList = ()=>{
        if (!tags) {
            return /*#__PURE__*/ _jsx(AdvancedFiltersListSkeleton, {});
        }
        return tags.data.map((tag)=>/*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(InputUI.CheckBox, {
                    id: tag.id,
                    htmlFor: tag.id,
                    type: "checkbox",
                    value: tag.name,
                    text: tag.name,
                    ...register("selectedStates")
                })
            }, tag.id));
    };
    return /*#__PURE__*/ _jsxs("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "h-[100%] flex flex-col justify-between",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "grow max-h-[calc(100%-40px)]",
                children: [
                    /*#__PURE__*/ _jsx(AdvancedFiltersNavigationHeader, {
                        onBack: onBack,
                        title: /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyLarge",
                            className: "text-neutral-700",
                            children: "Choose tags"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ _jsx(DebouncedSearch, {
                            placeholder: "Search for anything",
                            value: search,
                            onChange: onSearch
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 w-full max-h-[calc(100%-124px)] overflow-y-auto p-2 flex flex-col gap-6",
                        children: renderTagsList()
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-4 w-full",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "base",
                        onClick: onBack,
                        children: "Back"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        className: "w-full",
                        children: "Add Filter"
                    })
                ]
            })
        ]
    });
}
function AdvancedFiltersTagSkeleton(param) {
    let { className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("h-[20px] bg-neutral-100 animate-pulse rounded", className)
    });
}
function AdvancedFiltersListSkeleton() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[50%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[20%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[60%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[40%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[50%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[37%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[45%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[25%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[38%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[55%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[25%]"
            }),
            /*#__PURE__*/ _jsx(AdvancedFiltersTagSkeleton, {
                className: "w-[30%]"
            })
        ]
    });
}
